var map = {
	"./Csv64.png": "2d43",
	"./Dat64.png": "055f",
	"./DeadlineExpired64.png": "f223",
	"./Download32.png": "c24f",
	"./DownloadExcel32.png": "4c54",
	"./DownloadFile32.png": "9764",
	"./DownloadPdf32.png": "43da",
	"./Email-Reset-Password512.png": "9625",
	"./Email-Success512.png": "10c7",
	"./EmptyFolder64.png": "fd83",
	"./Error32.png": "12c7",
	"./Excel64.png": "b6fe",
	"./Expired64.png": "78d3",
	"./File64.png": "640f",
	"./GreenCircle64.png": "27ac",
	"./Link-Email256.png": "a029",
	"./Loading.gif": "1f37",
	"./Logo Dashboard.png": "6ef5",
	"./Logo-FB_Orange.png": "769c",
	"./Logo_Corgio-main-v2-250x250..png": "067c",
	"./Logo_Corgio-main-v2-250x250.png": "6fdb",
	"./Logo_Full-24x24.png": "c6bd",
	"./Pdf64.png": "b249",
	"./RedCircle64.png": "ea10",
	"./Search32.png": "4945",
	"./SearchNotFound64.png": "662f",
	"./SecurityWarning64.png": "cc6c",
	"./Txt64.png": "87c7",
	"./Validation_White -  20x20.png": "ab5a",
	"./Youtube32.png": "ed03",
	"./bg-login-page-dark.svg": "c5ac",
	"./bg-login-page.svg": "b946",
	"./btn-sign-in-with-google-light.png": "a597",
	"./btn-sign-in-with-google.png": "2f44",
	"./cotto-sanitary-wares.png": "7120",
	"./error-illustration.svg": "9487",
	"./error-page256.png": "fee8",
	"./food-beverage-1.jpg": "8066",
	"./food-beverage-10.jpg": "b1c5",
	"./food-beverage-11.jpg": "526f",
	"./food-beverage-12.jpg": "9d0b",
	"./food-beverage-13.jpg": "2116",
	"./food-beverage-14.jpg": "e42d",
	"./food-beverage-15.jpg": "920c",
	"./food-beverage-16.jpg": "4b68",
	"./food-beverage-17.jpg": "2279",
	"./food-beverage-18.jpg": "71b4",
	"./food-beverage-19.jpg": "3708",
	"./food-beverage-2.jpg": "dfc9",
	"./food-beverage-3.jpg": "f005",
	"./food-beverage-4.jpg": "83f8",
	"./food-beverage-5.jpg": "aa10",
	"./food-beverage-6.jpg": "f8a9",
	"./food-beverage-7.jpg": "58ad",
	"./food-beverage-8.jpg": "d32c",
	"./food-beverage-9.jpg": "4c7c",
	"./illustration.svg": "643f",
	"./logo.svg": "e347",
	"./lw-logo-lightwork-dark.png": "5443",
	"./lw-logo-lightwork.png": "0290",
	"./lw-logo-name-dark.png": "193d",
	"./lw-logo-name.png": "8311",
	"./lw-logo-peak-dark.png": "7da3",
	"./lw-logo-peak.png": "b3a9",
	"./lw-logo-temp.png": "1015",
	"./map-marker-region.png": "1976",
	"./map-marker.png": "4fad",
	"./more.png": "6664",
	"./peak-logo-new-design.png": "978d",
	"./phone-illustration.svg": "4664",
	"./preview-1.jpg": "fed3",
	"./preview-10.jpg": "cf2e",
	"./preview-11.jpg": "7531",
	"./preview-12.jpg": "c832",
	"./preview-13.jpg": "88d3",
	"./preview-14.jpg": "499f",
	"./preview-15.jpg": "3bac",
	"./preview-16.jpg": "60d7",
	"./preview-17.jpg": "b717",
	"./preview-18.jpg": "dabb",
	"./preview-19.jpg": "e3f4",
	"./preview-2.jpg": "d1e8",
	"./preview-3.jpg": "2bee",
	"./preview-4.jpg": "a3f7",
	"./preview-5.jpg": "0c34",
	"./preview-6.jpg": "b30e",
	"./preview-7.jpg": "56b1",
	"./preview-8.jpg": "dfad",
	"./preview-9.jpg": "7b28",
	"./profile-1.jpg": "317b",
	"./profile-1.png": "ebc5",
	"./profile-10.jpg": "99b3",
	"./profile-11.jpg": "6874",
	"./profile-12.jpg": "d662",
	"./profile-13.jpg": "c084",
	"./profile-14.jpg": "2208",
	"./profile-15.jpg": "dd46",
	"./profile-16.jpg": "38c7",
	"./profile-17.jpg": "8e75",
	"./profile-18.jpg": "2bd4",
	"./profile-19.jpg": "493b",
	"./profile-2.jpg": "fa45",
	"./profile-2.png": "d4ad",
	"./profile-3.jpg": "8b0b",
	"./profile-3.png": "5cc0",
	"./profile-4.jpg": "6a4f",
	"./profile-4.png": "a606",
	"./profile-5.jpg": "df2f",
	"./profile-5.png": "acde",
	"./profile-6.jpg": "e50c",
	"./profile-7.jpg": "28a7",
	"./profile-8.jpg": "8da4",
	"./profile-9.jpg": "535e",
	"./refresh.png": "15c8",
	"./register_img.png": "6280",
	"./woman-illustration.svg": "5234"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";